/**
 * A viewmodel representing Super Button.
 * @requires module:knockout
 * @requires module:helpers
 * @example
 * var superButtonData = viewModel.training.pageComponent.superButton.content;
 */

/**
 * @component {"type":"SuperButton","version":"1.0"}
 */

define('component-super-button',['knockout', 'helpers'], function(ko, helpers) {

    return function(parentVM) {
        var self = this,
            entityVM = parentVM.entity;

        self.content = ko.computed(function() {
            return helpers.component.getContent(entityVM.componentsJSON(), 'SuperButton');
        });

        self.runTasks = function() {
            var openTraining = helpers.component.parseProp(self.content(), 'openTraining', 'SetTraining'),
                customJS = helpers.component.parseProp(self.content(), 'customJS', 'CustomJS');

            if (openTraining.length) {
                var trainingId = openTraining[0].id,
                    classId = helpers.URL.getParam("classId"),
                    token = helpers.URL.getParam("tokenId"),
                    preview = helpers.URL.getParam("previewMode");

                window.open("/HtmlPlayer?id="+ trainingId +"&classId="+ classId +"&tokenId="+ token +"&previewMode="+ preview, "_self");
            }
            if (customJS.length) {
                var js = customJS[0].js;
                eval.call(window, js);
            }
        };

        self.label = ko.computed(function() {
            var content = self.content();

            return (content && content.buttonLabel) ? content.buttonLabel : '';
        });
    };

});

